import { render, staticRenderFns } from "./importApplications.vue?vue&type=template&id=2d6f562c&scoped=true"
import script from "./importApplications.vue?vue&type=script&lang=js"
export * from "./importApplications.vue?vue&type=script&lang=js"
import style0 from "./importApplications.vue?vue&type=style&index=0&id=2d6f562c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f562c",
  null
  
)

export default component.exports